// extracted by mini-css-extract-plugin
export default {"tiles":"MediaThumbnail_tiles__5OnZ3"};